import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ServiceCardsCarousel } from '../components/ServiceCardsCarousel';

const ServicesTestPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-black">
      <div className="relative overflow-hidden pt-36 pb-24">
        <div className="absolute top-0 left-0 w-96 h-96 bg-red-600/20 rounded-full filter blur-3xl" />
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-red-800/20 rounded-full filter blur-3xl" />

        <div className="container mx-auto px-4 lg:px-8 relative z-10">
          <div className="text-center mb-14">
            <p className="text-red-500 text-sm uppercase tracking-[0.3em] mb-3">Página de Teste</p>
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-black text-white mb-4">
              Service Cards <span className="text-red-600">Carrossel</span>
            </h1>
            <p className="text-gray-400 text-base md:text-lg max-w-2xl mx-auto">
              Design com imagens reais, overlays de transparência colorida e efeito peek
              (pedaço dos cards vizinhos visível nas laterais).
            </p>
          </div>

          <ServiceCardsCarousel onNavigate={navigate} />

          <p className="text-center text-gray-600 text-sm mt-8">
            Arraste, use as setas ou clique em um card para navegar
          </p>
        </div>
      </div>
    </div>
  );
};

export default ServicesTestPage;
